import { inject, injectable } from 'inversify';
import { TYPES } from '../ioc/types';
import type { LearningGuideStore } from '../stores/LearningGuide.store';
import type { Props as JoyRideProps, Step } from 'react-joyride';

@injectable()
export class LearningGuideService {
  private _learningGuideStore: LearningGuideStore;

  public constructor(@inject(TYPES.LearningGuideStore) store: LearningGuideStore) {
    this._learningGuideStore = store;
  }

  public setLearningGuideProps(joyRideProps: Omit<JoyRideProps, 'steps'>): void {
    this._learningGuideStore.setJoyRideProps(joyRideProps);
  }

  public setLearningGuideProp<K extends keyof Omit<JoyRideProps, 'steps'>>(prop: K, value: JoyRideProps[K]): void {
    this._learningGuideStore.setJoyRideProps({ ...this._learningGuideStore.joyRideProps, [prop]: value });
  }

  public setSteps(steps: Array<Step>): void {
    this._learningGuideStore.setSteps(steps);
  }

  public runLearningGuide(): void {
    this.setLearningGuideProp('run', true);
  }

  public stopLearningGuide(): void {
    this.setLearningGuideProp('run', false);
  }
}
